<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <div class="row">
        <div class="col-xs-12 col-md-5" v-if="selectedCustomer!==''">
          <q-card-section class="no-padding q-mb-xs">
            <q-expansion-item
                style="border-radius: 10px"
                icon="how_to_reg"
                :label="`${this.selectedSaleNum===''?'ثبت ':' ویرایش'} سفارش ${this.selectedSaleNum===''?'':selectedSaleNum} ${selectedCustomer.Cs_Name}`"
                header-class="bg-purple text-white"
                expand-icon-class="text-white"
            >
            </q-expansion-item>
          </q-card-section>
          <q-card-section class="no-padding">
            <q-expansion-item
                v-if="selectedCustomer!==''"
                :class="$q.screen.lt.md?'shadow-1 overflow-hidden q-mt-sm':'shadow-1 overflow-hidden'"
                style="border-radius: 10px"
                icon="group_work"
                label="جستجو در محصولات"
                header-class="bg-indigo-10 text-white"
                expand-icon-class="text-white"
                default-opened>
              <ProductInfoSearchPanel :customer-info="selectedCustomer"/>
              <ProductInfoSearchResult
                  :is-selection-form="true"
                  :by-pass-insert-dialog="true"
                  :show-groups="true"
                  @select-goods="insert_order"/>
            </q-expansion-item>
          </q-card-section>
        </div>
        <div :class="$q.screen.lt.md?'col-xs-12':' col-md-6 q-ml-xs'">
          <q-expansion-item
              v-if="selectedCustomer!==''"
              :class="$q.screen.lt.md?'shadow-1 overflow-hidden q-mt-sm':'shadow-1 overflow-hidden'"
              style="border-radius: 10px"
              icon="shopping_cart"
              label="سفارش"
              header-class="bg-indigo-10 text-white"
              expand-icon-class="text-white"
              default-opened>
            <q-card flat>
              <q-card-section class="no-padding text-center" v-if="!isShopOrder">
                <q-circular-progress
                    show-value
                    font-size="12px"
                    :value="100 - selectedCustomer.CustomerValue"
                    size="80px"
                    :thickness="0.22"
                    color="red-10"
                    track-color="red-2"
                    :max="100"
                    :min="0"
                >
                  {{ 100 - selectedCustomer.CustomerValue ? selectedCustomer.CustomerValue : 0 }}%
                </q-circular-progress>
                <q-space/>
                <q-chip label="ریسک معامله" color="red-10" text-color="white"/>
              </q-card-section>
              <q-card-actions v-if="selectedCustomer!==''" align="center">
                <q-btn :label="!selectedSaleNum? orderInfo.isFinalOrder?'ثبت سفارش نهایی':'ثبت سفارش' : 'ویرایش سفارش'"
                       type="button"
                       v-if="orderList.length>0"
                       @click="SendOrder"
                       :disable="orderList.length===0 || inProgress"
                       class="bg-indigo-6 text-white" icon="add_shopping_cart"/>
                <q-btn label="انصراف" @click="onReset" flat class="q-ml-sm" icon="cancel" color="red"/>
              </q-card-actions>
              <q-card-section class="no-padding">
                <q-toggle disable v-if="false" color="red"
                          v-model="orderInfo.isFinalOrder">
                  <span class="text-red-14 text-bold">سفارش نهایی گردد</span>
                </q-toggle>
                <q-input :dense="$q.screen.lt.md" filled class="q-pa-xs"
                         v-model="orderInfo.orderDescription"
                         label="در صورت نیاز شرحی مختصر برای سفارش اینجا وارد نمایید"/>
                <q-chip :size="$q.screen.lt.md?'md':'lg'" square flat
                        class="text-weight-bolder no-padding"
                        label="مبلغ کل سفارش">
                  <q-chip :size="$q.screen.lt.md?'md':'md'" square class="q-ml-xs text-weight-bold"
                          color="red-14"
                          text-color="white">
                    {{
                      orderTotalCost !== '' && orderTotalCost !== 0 ? orderTotalCost.toLocaleString() : 0
                    }} ریال
                  </q-chip>
                </q-chip>
                <q-chip :size="$q.screen.lt.md?'md':'lg'" square flat
                        class="text-weight-bolder no-padding"
                        label="تعداد کارتن">
                  <q-chip :size="$q.screen.lt.md?'md':'md'" square class="q-ml-xs text-weight-bold"
                          color="red-14"
                          text-color="white">
                    {{
                      Math.round(lodash.sumBy(orderList.filter(rec => rec.Goods_Box), item => parseInt(item.amount) / item.Goods_Box)).toLocaleString()
                    }}
                  </q-chip>
                </q-chip>
              </q-card-section>
              <q-card-section class="no-padding">
                <q-table
                    :data="orderList"
                    :columns="order_columns"
                    row-key="Table_IDD"
                    hide-header
                    flat
                    wrap-cells>
                  <template v-slot:body="props">
                    <q-tr :props="props" class="my-class">
                      <q-td>
                        <q-card class="shadow-5">
                          <q-card-section horizontal>
                            <q-card-actions class="justify-around">
                              <q-btn flat dense round color="red" icon="delete"
                                     @click="deleteRow(props.row)"/>
                            </q-card-actions>
                            <div class="col">
                              <div class="text-bold">
                                <q-chip :label="props.rowIndex + 1"
                                        text-color="white"
                                        color="brown">
                                  <q-tooltip content-class="bg-indigo"
                                             v-if="props.row.lastSaleInfo">
                                    <span class="text-subtitle2">آخرین خرید طرف معامله</span>
                                    <span> در تاریخ </span>
                                    <span
                                        class="text-red text-subtitle2">
                                    {{ props.row.lastSaleInfo.Sale_Date }}</span>
                                    <span> و به مبلغ واحد </span> <span
                                      class="text-red text-subtitle2">
                                    {{ props.row.lastSaleInfo.SaleG_PricePure.toLocaleString() }}</span>
                                    <span> و تعداد </span> <span
                                      class="text-red text-subtitle2">
                                  {{ props.row.lastSaleInfo.SaleG_Count }} </span>
                                    <span> {{ props.row.lastSaleInfo.Unit_Name }} </span>
                                    <span> می باشد</span>
                                  </q-tooltip>
                                </q-chip>
                                <q-chip :label="props.row.Goods_Code"
                                        color="red"
                                        square
                                        @click="showProductDetailsDialogByID(props.row)"
                                        clickable
                                        text-color="white"/>
                                <q-icon v-if="(props.row.List_Price>0 && props.row.List_Price<props.row.BuyDay_Price) ||
                                             props.row.SaleG_PricePure< props.row.BuyDay_Price"
                                        name="warning" color="red" size="sm">
                                  <q-tooltip>
                                    قیمت لیست و یا قیمت خالص از قیمت خرید روز کمتر است
                                  </q-tooltip>
                                </q-icon>
                                <span> {{ props.row.title }}</span>
                                <span v-if="props.row.Goods_Pack && props.row.Goods_Pack>0">
                                  <q-chip label="تعداد در کارتن" square>
                                    <q-badge class="q-ml-xs" :label="props.row.Goods_Pack"/>
                                  </q-chip>
                                </span>
                              </div>
                              <div v-if="props.row.Goods_SaleTax_D && props.row.Goods_SaleTax_D>0">
                                <q-chip square color="red" text-color="white" size="sm"
                                        :label="`شامل ${props.row.Goods_SaleTax_D} درصد ارزش افزوده می باشد `"/>
                              </div>
                              <div>
                                <q-card flat>
                                  <q-card-section class="no-padding" :horizontal="!$q.screen.lt.md">
                                    <q-input dense label-color="indigo" type="number"
                                             style="width:130px;"
                                             outlined
                                             class="text-center " dir="ltr"
                                             label="تعداد سفارش" v-model="props.row.amount"
                                             :hint="`تعداد کارتن (${Math.round(props.row.amount/props.row.Goods_Box)})`"
                                             @change="onAmountChange(props.row)">
                                    </q-input>
                                    <q-chip :size="$q.screen.lt.md?'sm':'md'" square
                                            label="قیمت">
                                      <q-badge color="purple" align="top">
                                        <b>{{ props.row.SaleG_Price | toCurrency }}</b>
                                      </q-badge>
                                    </q-chip>
                                    <q-chip :size="$q.screen.lt.md?'sm':'md'" square
                                            label="قیمت خالص">
                                      <q-badge color="purple" align="top">
                                        <b>{{
                                            props.row.SaleG_PricePure | toCurrency
                                          }}</b>
                                      </q-badge>
                                      <q-btn icon="edit" flat round size="sm"
                                             text-color="purple">
                                        <q-popup-edit
                                            persistent
                                            buttons
                                            :validate="val=>validateSaleGPrice(val, props.row)"
                                            @save="(val, initialValue) => updateSaleGPrice(val, initialValue, props.row)"
                                            v-model="props.row.SaleG_PricePure"
                                        >
                                          <q-card flat>
                                            <q-card-section class="no-padding"
                                                            v-if="props.row.List_Price && props.row.List_Price>0">
                                              <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="لیست">
                                                <q-badge color="blue" class="q-ml-xs">
                                                  {{ props.row.List_Price | toLoalString }}
                                                </q-badge>
                                              </q-chip>
                                            </q-card-section>
                                            <q-card-section class="no-padding">
                                              <q-field
                                                  v-model="props.row.SaleG_PricePure"
                                                  mask="currency"
                                                  label="مبلغ فروش"
                                                  label-color="indigo"
                                                  autofocus
                                                  filled
                                                  dir="ltr"
                                                  lazy-rules
                                                  :rules="[
                                           val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ فروش را وارد نمایید',
                                           val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ فروش عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                                         ]">
                                                <template
                                                    v-slot:control="{ id, floatingLabel, value, emitValue }">
                                                  <input :id="id"
                                                         class="q-field__native text-right"
                                                         :value="value"
                                                         @change="e => emitValue(e.target.value.replaceAll(',',''))"
                                                         v-money="moneyFormatForDirective"
                                                         v-show="floatingLabel">
                                                </template>
                                              </q-field>
                                              <q-input v-model="props.row.OriginSaleG_PricePurePercent"
                                                       step="0.1"
                                                       type="number"
                                                       label="درصد"
                                                       dir="ltr"
                                                       @change="e=> changeSaleG_PricePurePercent(props.row)"
                                                       filled>
                                                <template v-slot:append>
                                                  <q-icon name="percent"/>
                                                </template>
                                              </q-input>
                                            </q-card-section>
                                          </q-card>
                                        </q-popup-edit>
                                      </q-btn>
                                      <q-badge align="top" class="q-ml-xs"
                                               color="green-10"
                                               :label="`${props.row.SaleG_Off_D}%`"
                                               v-if="props.row.SaleG_Off_D && props.row.SaleG_Off_D >0">
                                      </q-badge>
                                    </q-chip>
                                    <q-chip :size="$q.screen.lt.md?'sm':'md'" square
                                            label="قیمت کل">
                                      <q-badge color="orange" align="top">
                                        <b>
                                          {{
                                            props.row.amount * props.row.SaleG_PricePure.toString().replaceAll(',', '') | toLoalString
                                          }}
                                        </b>
                                      </q-badge>
                                    </q-chip>
                                  </q-card-section>
                                  <q-card-section
                                      v-if="$store.state.roles.some(v=>['admin','can_sea_goods_profit'].includes(v))"
                                      class="no-padding q-mt-xs">
                                    اختلاف با قیمت روز

                                    <q-badge align="top"
                                             dir="ltr"
                                             :color="(((parseInt(props.row.SaleG_PricePure) - parseInt(props.row.BuyDay_Price)) / parseInt(props.row.BuyDay_Price)) * 100).toFixed(2) < 0?'red-10':'green'"
                                             text-color="white"
                                             :label="`${(((parseInt(props.row.SaleG_PricePure) - parseInt(props.row.BuyDay_Price)) / parseInt(props.row.BuyDay_Price)) * 100).toFixed(2)}%`"/>
                                    <q-badge class="q-ml-xs" align="top"
                                             :color="(((parseInt(props.row.SaleG_PricePure) - parseInt(props.row.BuyDay_Price)) / parseInt(props.row.BuyDay_Price)) * 100).toFixed(2) < 0?'red-10':'green'"
                                             text-color="white"
                                             dir="ltr"
                                             :label="`${(parseInt(props.row.SaleG_PricePure) - parseInt(props.row.BuyDay_Price)).toLocaleString()} ریال`"/>
                                  </q-card-section>
                                </q-card>
                              </div>
                              <div>
                                <q-toggle color="red-14" class="text-subtitle2"
                                          v-model="props.row.Can_See_Off_Value"
                                          :label="props.row.Can_See_Off_Value===false?'تخفیف در چاپ نمایش داده نشود':'تخفیف در چاپ نمایش داده شود'"/>
                              </div>
                            </div>
                          </q-card-section>
                        </q-card>
                        <q-separator/>
                      </q-td>
                    </q-tr>
                  </template>
                </q-table>
              </q-card-section>
            </q-card>
          </q-expansion-item>
        </div>
      </div>
    </q-card-section>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>
    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="addProductDialog">
      <q-card style="width: 400px; max-width: 80vw;">
        <q-card-section>
          <div class="text-bold">
            <q-btn round color="indigo" padding="none" text-color="white" icon="info"
                   @click="showProductDetails=true"/>
            {{ selectedProduct.title }}
          </div>
          <q-badge class="bg-red-14"><i>موجودی(</i><b>{{ selectedProduct.Goods_Stock }}</b><i>)
            {{ selectedProduct.Unit_Name }}</i></q-badge>
        </q-card-section>
        <q-card-section v-if="selectedProduct.lastSaleInfo">
          <span class="text-subtitle2">آخرین خرید طرف معامله</span> <span> در تاریخ </span> <span
            class="text-red text-subtitle2"> {{ selectedProduct.lastSaleInfo.Sale_Date }}</span>
          <span> و به مبلغ واحد </span> <span
            class="text-red-10 text-subtitle2">
          {{ selectedProduct.lastSaleInfo.SaleG_PricePure.toLocaleString() }}</span>
          <span> و تعداد </span> <span class="text-red text-subtitle2"> {{
            selectedProduct.lastSaleInfo.SaleG_Count
          }} </span>
          <span> {{ selectedProduct.lastSaleInfo.Unit_Name }} </span>
          <span> می باشد</span>
        </q-card-section>
        <q-form autofocus greedy
                @submit="onDialogSubmit"
                @reset="onDialogReset"
                class="q-gutter-md q-gutter-sm">
          <q-card-section>
            <q-input
                :dense="$q.screen.lt.md"
                v-model="inputProductAmount"
                filled
                type="number"
                label="تعداد درخواستی"
                autofocus
                dir="ltr"
                :rules="[
                          val => val !== null && val !== '' || 'تعداد درخواستی را وارد نمایید',
                          val => val > 0  || 'تعداد درخواستی عددی بزرگتر از صفر می تواند باشد'
                        ]"
            />
            <q-separator/>
            <div class="items-center justify-center row q-mt-xs q-mt-sm q-mt-ma">
              <q-badge class="bg-purple-14 q-mr-xs q-pa-xs"><i>تعداد در بسته(</i><b>
                {{ selectedProduct.Goods_Pak }}</b><i>)
                {{ selectedProduct.Unit_Name }}</i></q-badge>
              <q-badge class="bg-indigo-14 q-ml-xs q-pa-xs"><i>تعداد در
                کارتن(</i><b>{{ selectedProduct.Goods_Box }}</b><i>)
                {{ selectedProduct.Unit_Name }}</i></q-badge>
            </div>
          </q-card-section>

          <q-card-section>
            <span class="text-subtitle1">موجودی به تفکیک انبار</span>
            <q-space/>
            <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="مرکزی">
              <q-badge color="deep-orange-10" class="q-ml-xs">{{ selectedProduct.GStor1 }}</q-badge>
            </q-chip>
            <q-space v-if="$q.screen.lt.md"/>
            <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="فروشگاه">
              <q-badge color="deep-orange-10" class="q-ml-xs">{{ selectedProduct.GStor2 }}</q-badge>
            </q-chip>
            <q-space v-if="$q.screen.lt.md"/>
            <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="پل پنجم">
              <q-badge color="blue" class="q-ml-xs">{{ selectedProduct.GStor3 }}</q-badge>
            </q-chip>
            <q-space v-if="$q.screen.lt.md"/>
            <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="کارخانه صاف">
              <q-badge color="pink" class="q-ml-xs">
                {{ selectedProduct.GStor4 }}
              </q-badge>
            </q-chip>
            <q-space v-if="$q.screen.lt.md"/>
            <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="دیجیکالا">
              <q-badge color="pink" class="q-ml-xs">
                {{ selectedProduct.GStor6 }}
              </q-badge>
            </q-chip>
          </q-card-section>

          <q-card-actions align="right">
            <q-btn label="تایید" type="submit" color="primary" icon="check" v-close-popup/>
            <q-btn flat label="انصراف" color="red" icon="cancel" v-close-popup/>
          </q-card-actions>
        </q-form>
      </q-card>
    </q-dialog>


    <q-dialog :maximized="$q.screen.lt.md" v-model="goodsEditDialog">
      <GoodsStore :goods-info="selectedProduct"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="goodsStateDialog">
      <ChangeState :goods-info="selectedProduct"/>
    </q-dialog>

    <q-dialog v-model="showOrderRemittanceDialog" maximized>
      <IssueOrderRemittance
          :order-num="parseInt(selectedOrderNum)"
          :is-shop-order="true"
          @refresh-data="closeIssueOrder"/>
    </q-dialog>

  </q-card>
</template>

<script>
import EventBus from "@/event-bus";
import {mapActions} from 'vuex'
import GoodsStore from "@/components/store/GoodsStore";
import ProductInfoSearchResult from "@/components/productInfo/ProductInfoSearchResult";
import ProductInfoSearchPanel from "@/components/productInfo/ProductInfoSearchPanel";
import ChangeState from "@/components/products/ChangeState";
import IssueOrderRemittance from "@/components/Remittance/IssueOrderRemittance.vue";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";


export default {
  name: "ProductSearchResults",
  components: {
    ProductDetail,
    IssueOrderRemittance,
    ChangeState,
    ProductInfoSearchPanel, ProductInfoSearchResult, GoodsStore
  },
  props: {
    isShopOrder: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      selectedOrderNum: undefined,
      showOrderRemittanceDialog: false,
      goodsStateDialog: false,
      goodsEditDialog: false,
      filter: 'false',
      productList: [],
      orderList: [],
      existsOrderList: false,
      selectedSaleNum: '',
      orderInfo: {
        orderDescription: '',
        isFinalOrder: false,
        isShopOrder: this.isShopOrder
      },
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      inProgress: false,
      selectedProduct: '',
      selectedProductDetails: '',
      selectedCustomer: '',
      showProductDetails: false,
      orderTotalCost: '',
      order_item: {
        product_id: null,
        title: null,
        amount: null
      },
      addProductDialog: false,
      pagination: {
        rowsPerPage: 10
      },
      columns: [
        {
          name: 'title',
          label: 'عنوان کالا(موجودی، مبلغ)',
          field: 'title',
          sortable: true,
          align: 'left',
        }
      ],
      order_columns: [
        {
          name: 'title',
          label: 'عنوان کالا',
          field: 'title',
          sortable: true,
          align: 'left',
          style: 'text-align:right',
        },
        {
          name: 'amount',
          label: 'تعداد/مقدار',
          field: 'amount',
          sortable: true,
          align: 'center',
          style: 'text-align:center',
        },
        {
          name: 'SaleG_Total',
          label: 'قیمت کل',
          field: 'SaleG_Total',
          sortable: true,
          align: 'center',
          style: 'text-align:center',
        },
        {name: 'actions', label: '', field: '', align: 'center'}
      ],
      inputProductAmount: null,
      SaleG_PricePerc: 0
    }
  },
  methods: {
    ...mapActions({
      AddOrder: 'Orders/addOrder',
      EditOrder: 'Orders/EditOrder',
      GetOrderItemInfo: 'Orders/getOrderItemInfo',
      getProductById: 'Products/getByID',
      getProductListBuGroupID: 'Products/getByGroupID',
      getLastCustomerSaleGoodsInfo: 'Products/getLastSaleGoodByCustomer',
    }),
    closeIssueOrder() {
      this.showOrderRemittanceDialog = false
    },
    changeSaleG_PricePurePercent(rowInfo) {
      if (rowInfo.List_Price && rowInfo.List_Price > 0) {
        const increaseNumber = rowInfo.List_Price * (rowInfo.OriginSaleG_PricePurePercent / 100)
        rowInfo.SaleG_PricePure = Math.round(rowInfo.List_Price + increaseNumber)
      } else {
        const increaseNumber = rowInfo.OriginSaleG_PricePure * (rowInfo.OriginSaleG_PricePurePercent / 100)
        rowInfo.SaleG_PricePure = Math.round(rowInfo.OriginSaleG_PricePure + increaseNumber)
      }
    },
    validateSaleGPrice(val, row) {
      if (this.$store.state.roles.some(v => ['admin', 'can_use_open_price'].includes(v))) {
        return true
      } else {
        if (parseInt(val.toString().replaceAll(',', '')) < (row.SaleG_Price - (row.SaleG_Price * (row.LowLimit / 100.0)))) {
          this.$q.notify({
            message: ` امکان فروش کمتر از ${row.LowLimit} نقد کارتن میسر نمی باشد`,
            color: 'deep-orange',
            position: 'top',
            type: 'negative'
          });
          return false
        } else {
          return true
        }
      }
    },
    updateSaleGPrice(val, initialValue, row) {
      row.SaleG_PricePure = val.toString().replaceAll(',', '')
      if (parseInt(row.SaleG_PricePure) >= parseInt(row.SaleG_Price)) {
        row.profit = 0
        row.SaleG_Off = 0
        row.SaleG_Off_D = 0
      } else {
        if (row.List_Price > 0) {
          row.profit = (((row.List_Price - row.SaleG_PricePure) / row.List_Price) * 100).toFixed(2)
          row.SaleG_Off_D = row.profit
        } else {
          row.profit = (((row.BuyDay_Price - row.SaleG_PricePure) / row.BuyDay_Price) * 100).toFixed(2)
          row.SaleG_Off_D = row.profit
        }

        row.SaleG_Off_D = row.profit
        this.CalculateOrderTotalCost();
      }
    },
    onDialogSubmit() {
      if (this.inputProductAmount === null || this.inputProductAmount === '' || this.inputProductAmount <= 0) return;
      let checkExists = this.orderList.filter(row => row.product_id === this.selectedProduct.ID).length > 0;
      if (checkExists === true) {
        this.$q.notify({
          message: 'محصول قبلا به سبد سفارش افزوده شده است!',
          color: 'deep-orange',
          position: 'top',
          type: 'negative'
        });
      } else {
        let selectedOrder = {
          customerId: this.selectedCustomer.Cs_ID,
          product_id: this.selectedProduct.ID,
          title: this.selectedProduct.title,
          amount: this.inputProductAmount,
          latitude: 0,
          longitude: 0,
          accuracy: 0,
          Goods_Code: 0,
          OriginSaleG_PricePurePercent: 0,
          OriginSaleG_PricePure: 0,
          Goods_Pack: this.selectedProduct.Goods_Pack
        };
        this.GetOrderItemInfo(selectedOrder).then((res) => {
          selectedOrder.SaleG_Price = Math.round(res.data[0].SaleG_Price);
          selectedOrder.SaleG_PricePure = Math.round(res.data[0].SaleG_PricePure);
          selectedOrder.Goods_Code = res.data[0].Goods_Code;
          selectedOrder.BuyDay_Price = Math.round(res.data[0].BuyDay_Price)
          selectedOrder.profit = (((parseInt(selectedOrder.SaleG_Price.toString().replaceAll(',', '')) - res.data[0].BuyDay_Price) / res.data[0].BuyDay_Price) * 100).toFixed(2)
          this.$getLocation({
            timeout: Infinity
          }).then(coordinates => {
            selectedOrder.latitude = coordinates.lat;
            selectedOrder.longitude = coordinates.lng;
            selectedOrder.accuracy = coordinates.accuracy;
          })
          selectedOrder.SaleG_Off_D = res.data[0].SaleG_Off_D;
          selectedOrder.SaleG_Off = res.data[0].SaleG_Off;
          selectedOrder.List_Price = res.data[0].List_Price;
          selectedOrder.Can_See_Off_Value = false
          selectedOrder.lastSaleInfo = this.selectedProduct.lastSaleInfo
          selectedOrder.SaleG_PricePerc = 0;
          selectedOrder.OriginSaleG_PricePurePercent = 0
          selectedOrder.OriginSaleG_PricePure = Math.round(res.data[0].SaleG_PricePure)
          if (this.isShopOrder) {
            selectedOrder.SaleG_PricePure = res.data[0].Etehadie_Price
            selectedOrder.SaleG_Price = res.data[0].Etehadie_Price
          }
          this.orderList.push(selectedOrder);
          this.CalculateOrderTotalCost();
          this.inputProductAmount = null;
          this.addProductDialog = false;
          this.$q.notify({
            message: 'محصول به سفارش اضافه شد',
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
        });
      }
    },
    onDialogReset() {
      this.inputProductAmount = null;
    },
    insert_order(row) {
      if (row.dependencies) {
        const dependencies = JSON.parse(row.dependencies).map(item => item.DependencyGoods_ID)
        if (this.orderList.filter(item => dependencies.includes(item.product_id)).length !== dependencies.length) {
          this.$q.notify({
            message: 'وابستگی محصول رعایت نشده است',
            color: 'red',
            position: 'top',
            type: 'positive'
          });
        } else {
          this.addRow(row)
        }
      } else {
        this.addRow(row)
      }
    },
    addRow(row) {
      if ((row.BuyDay_Price === 0 || row.BuyLast_Price === 0) && row.Goods_Stock !== 0) {
        this.$q.notify({
          message: 'محصول فاقد قیمت خرید روز و خرید اصلی است',
          color: 'red',
          position: 'top',
          type: 'positive'
        });
      } else {
        this.getLastCustomerSaleGoodsInfo(
            {
              CustomerId: this.selectedCustomer.Cs_ID,
              GoodsId: row.Goods_ID
            }).then((res) => {
          this.selectedProduct = row;
          if (res.length > 0) {
            this.selectedProduct.lastSaleInfo = res[0]
          }
          this.selectedProductDetails = row;
          this.addProductDialog = true;
          this.order_item.title = null;
          this.order_item.amount = null;
          this.order_item.product_id = null;
          this.selectedProductDetails.Can_See_Off_Value = true
        })
      }
    },
    deleteRow(row) {
      this.orderList.splice(this.orderList.indexOf(row), 1);
      this.CalculateOrderTotalCost();
      this.$q.notify({
        message: 'محصول از سفارش حذف گردید',
        color: 'red',
        position: 'top',
        type: 'positive'
      });
    },
    SendOrder() {
      this.orderInfo.isShopOrder = this.isShopOrder
      this.inProgress = true
      this.orderList.forEach((record) => {
        record.SaleG_Price = record.SaleG_Price.toString().replaceAll(',', '')
        record.latitude = 0;
        record.longitude = 0;
        record.accuracy = 0;
      })
      if (this.selectedSaleNum !== '') {
        this.$getLocation({
          timeout: Infinity
        }).then(coordinates => {
          this.orderList.forEach((record) => {
            record.latitude = coordinates.lat;
            record.longitude = coordinates.lng;
            record.accuracy = coordinates.accuracy;
          })
        });
        this.EditOrder({
          ecap_customer_id: this.selectedCustomer.Cs_ID,
          sale_num: this.selectedSaleNum,
          orderInfo: this.orderInfo,
          orderList: this.orderList,
          isShopOrder: this.isShopOrder
        }).then((res) => {
          if (res.data.length > 0) {
            this.$q.notify({
              message: `سفارش به شماره ${res.data[0].Sale_Num}  ویرایش گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
            this.onReset();
          } else {
            this.$q.notify({
              message: `امکان ثبت سفارش وجود ندارد، جهت اطلاعات بیستر با بخش انفورماتیک تماس بگیرید`,
              color: 'red',
              position: 'top',
              type: 'negative'
            });
          }
        }).catch(() => {
          this.inProgress = false
        });
      } else {
        this.AddOrder({
          ecap_customer_id: this.selectedCustomer.Cs_ID,
          orderInfo: this.orderInfo,
          orderList: this.orderList,
        }).then((res) => {
          if (res.data.length > 0) {
            this.$q.notify({
              message: `سفارش به شماره ${res.data[0].Sale_Num}  ارسال گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
            this.onReset();
            if (this.isShopOrder) {
              this.selectedOrderNum = res.data[0].Sale_Num
              this.showOrderRemittanceDialog = true

            }
          } else {
            this.$q.notify({
              message: `امکان ثبت سفارش وجود ندارد، جهت اطلاعات بیستر با بخش انفورماتیک تماس بگیرید`,
              color: 'red',
              position: 'top',
              type: 'negative'
            });
          }
        });
      }
    },
    showProductDetailsDialog(row) {
      this.selectedProductDetails = row;
      this.showProductDetails = true
    },
    showProductDetailsDialogByID(row) {
      this.getProductById(row.product_id).then((res) => {
        this.selectedProductDetails = res[0];
        this.selectedProductDetails.imageUrl = '';
        this.showProductDetails = true;
      })
    },
    onAmountChange(row) {
      if (this.selectedCustomer.Cs_ID !== 6899) {
        this.GetOrderItemInfo({
          product_id: row.product_id,
          amount: parseInt(row.amount),
          customerId: this.selectedCustomer.Cs_ID
        }).then((res) => {
          row.SaleG_Price = res.data[0].SaleG_Price;
          row.SaleG_PricePure = res.data[0].SaleG_PricePure;
          this.CalculateOrderTotalCost();
          this.$q.notify({
            message: 'قیمت پایه محصول به روز رسانی گردید',
            color: 'purple',
            position: 'top',
            type: 'positive'
          });
        })
      }
      this.CalculateOrderTotalCost();
    },
    CalculateOrderTotalCost() {
      this.orderTotalCost = this.CurrencyShow(this.lodash.sumBy(this.orderList, x => parseInt(x.amount) * parseInt(x.SaleG_PricePure.toString().replaceAll(',', ''))));
    },
    showExistsProduct(data) {
      if (data.length > 0) {
        if (this.filter === 'true') {
          return data.filter(row => row.Goods_Stock > 0);
        } else {
          return data;
        }
      }
      return data;
    },
    onReset() {
      EventBus.$emit('invoke-product-search-result-event', []);
      EventBus.$emit('invoke-selected-customer', '');
      EventBus.$emit('invoke-selected-exists-orderList', '');
      this.selectedSaleNum = '';
      EventBus.$emit('invoke-selected-sale_num', this.selectedSaleNum = '');
      this.existsOrderList = false;
      this.inProgress = false;
      this.orderList = [];
      this.orderTotalCost = '';
      this.orderInfo = {
        orderDescription: '',
        isFinalOrder: false
      }
    },
    groupSelected(args) {
      EventBus.$emit('invoke-group-selected-event', args);
      this.getProductListBuGroupID(args.Group_ID).then((res) => {
        this.productList = res
        EventBus.$emit('invoke-productinfo-search-result-event', this.productList);
      })
    },
  },
  mounted() {
    EventBus.$on('invoke-product-search-result-event', payload => {
      this.productList = payload;
    });
    EventBus.$on('invoke-selected-customer', payload => {
      // if (payload) {
      //   this.getCustomerInfo(payload.Cs_ID).then((res) => {
      //     this.selectedCustomer = res.data[0];
      //   })
      // } else {
      //   this.selectedCustomer = payload
      // }

      this.selectedCustomer = payload
      this.orderList = [];
      this.orderTotalCost = '';
      this.orderInfo = {
        orderDescription: '',
        isFinalOrder: false
      }
    });

    EventBus.$on('invoke-selected-sale_num', payload => {
      this.selectedSaleNum = payload;
    });

    EventBus.$on('invoke-selected-exists-orderList', payload => {
      if (this.orderList.length === 0) {
        this.existsOrderList = true;
        this.orderList = payload;
        if (payload !== '') {
          this.orderList.forEach((record) => {
            record.profit = record.SaleG_Off_D
            record.SaleG_PricePerc = 0
          })
          this.CalculateOrderTotalCost();
        }
      }
    });

    EventBus.$on('invoke-selected-exists-order-info', payload => {
      if (payload) {
        this.orderInfo.orderDescription = payload.Sale_Desc;
      }
    });
  },
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>